export async function httpRequest(base, path, options = {}) {
  // Ensure Content-Type is application/json for requests with body
  const defaultHeaders = { 'Content-Type': 'application/json' };
  const headers = { ...defaultHeaders, ...(options.headers || {}) };
  
  // HTTP request logging removed for production
  
  const res = await fetch(`${base}${path}`, {
    headers,
    credentials: 'include',
    redirect: 'follow',
    ...options,
  });
  if (res.status === 401) {
    // Redirect to login on unauthorized
    if (typeof window !== 'undefined') {
      const here = window.location.pathname + window.location.search;
      const to = here.includes('/login') ? '/login' : `/login?next=${encodeURIComponent(here)}`;
      if (!window.location.pathname.startsWith('/login')) window.location.assign(to);
    }
    throw new Error('Unauthorized');
  }
  if (!res.ok) {
    let body;
    try { body = await res.json(); } catch (_) { body = { error: res.statusText }; }
    throw new Error(body?.error || `Request failed (${res.status})`);
  }
  try { return await res.json(); } catch (_) { return null; }
}
